import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Download as DLIcon, X } from "lucide-react";
import { toast } from "sonner";

export default function LeadGateModal({ download, onClose, onUnlock }) {
    const [form, setForm] = useState({ name: "", email: "", company: "", phone: "" });
    const [loading, setLoading] = useState(false);

    function set(k, v) { setForm((f) => ({ ...f, [k]: v })); }

    async function submit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/leads", {
                ...form,
                download_id: download.id,
                download_title: download.title,
            });
            try { await api.post(`/downloads/${download.id}/increment`); } catch {}
            onUnlock();
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail) || "Could not submit");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="fixed inset-0 bg-ink/70 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="lead-gate-modal">
            <form onSubmit={submit} className="bg-white max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-2">
                    <h3 className="font-display text-2xl font-bold">Almost there!</h3>
                    <button type="button" onClick={onClose}><X className="w-5 h-5" /></button>
                </div>
                <p className="text-sm text-muted-foreground mb-6">
                    Quick details and we'll unlock <strong className="text-ink">{download.title}</strong> instantly. We may also follow up with relevant offers — never spam.
                </p>
                <div className="grid gap-3 mb-4">
                    <input required value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Full name" className="border border-border px-3 py-2.5 focus:outline-none focus:border-primary" data-testid="lead-name" />
                    <input required type="email" value={form.email} onChange={(e) => set("email", e.target.value)} placeholder="Work email" className="border border-border px-3 py-2.5 focus:outline-none focus:border-primary" data-testid="lead-email" />
                    <input value={form.company} onChange={(e) => set("company", e.target.value)} placeholder="Company (optional)" className="border border-border px-3 py-2.5 focus:outline-none focus:border-primary" data-testid="lead-company" />
                    <input value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="Phone (optional)" className="border border-border px-3 py-2.5 focus:outline-none focus:border-primary" data-testid="lead-phone" />
                </div>
                <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-primary text-white py-2.5 font-semibold hover:bg-primary-hover disabled:opacity-50" data-testid="lead-submit">
                    <DLIcon className="w-4 h-4" /> {loading ? "Unlocking…" : "Unlock download"}
                </button>
                <div className="text-[10px] text-muted-foreground text-center mt-3">
                    By submitting you agree to be contacted by Peppa Target Services. You can unsubscribe anytime.
                </div>
            </form>
        </div>
    );
}
